<template>
  <div>
    <div class="entry-contents-ttl container-xl text-center">
      <h2>パスワードリセット</h2>
    </div>

    <div class="container-xl px-lg-0">
      <div class="row row-flow">
        <div class="col-3">
          <div class="flow-item rounded-start current">メールアドレス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item">ワンタイムパス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item">必要事項<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item">完了</div>
        </div>
      </div>
    </div>

      <main class="container-xl">
        <div class="primary-area">
          <section>
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  登録メールアドレス<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9 text-left border-b pb-4">
                <Input
                  placeholder="sample@example.com"
                  required
                  class="form-control"
                  :class="{
                    'form-error': formErrors.emailVerification.errors.email.length > 0,
                  }"
                  v-model="formData.emailVerification.email"
                />
                <div class="small notes notes-error">
                  {{ formErrors.emailVerification.getErrorMsg('email') }}
                </div>
                <div class="small notes">パスワードをリセットするためのワンタイムパスをお送りします。
                </div>
              </dd>
            </dl>
            <div class="text-center mb-3 mt-md-2 mb-sm-1">
              <Button
                :disabled="!isScreenActive"
                @click="validate"
              >メールを送信する</Button>
            </div>
            <div class="text-center mt-3">
              <Link class="small" @click="toSignInForm">ログイン画面に戻る</Link>
            </div>
          </section>
        </div><!-- end .primary-area-->
      </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Button, Input, Link } from "components";
import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";
import {
  EmailVerification,
  EMAIL_VERIFICAION_STATUS_CD,
  EMAIL_VERIFICAION_AUTH_TYPE_CD,
} from "models/email-verification";
import {
  EmailVerificationSendAuthCodeValidator,
} from "validators/email-verifications";

// リポジトリ
import { RepositoryFactory } from "repositories/factory";

const ResetPasswordRepository = RepositoryFactory.get("reset-password");

export default {
  name: "Sample",
  components: {
    Button,
    Input,
    Link,
  },
  data() {
    return {
      formData: {
        emailVerification: new EmailVerification(),
      },
      formErrors: {
        emailVerification: new EmailVerificationSendAuthCodeValidator(),
      },
    };
  },
  computed: {
    ...mapGetters({
      isScreenActive: "application/isScreenActive",
    }),
  },
  async created() {
    await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      resetNotification: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
      // email-verification
      updateResetPasswordEmailVerification: "email-verification/updateResetPasswordEmailVerification",
    }),
    async validate() {
      try {
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);
        await this.resetNotification();

        // 入力バリデーション
        this.formErrors.emailVerification = EmailVerificationSendAuthCodeValidator.validate(
          this.formData.emailVerification,
        );

        if (!this.formErrors.emailVerification.result) {
          // this.addErrorNotification("バリデーションエラー");
          await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        } else {
          this.submit();
        }
      } catch (err) {
        console.log(err);
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    async submit() {
      try {
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);

        const res = await ResetPasswordRepository.startEmailVerification(
          this.formData.emailVerification.email,
        );
        this.formData.emailVerification.authTypeCd = EMAIL_VERIFICAION_AUTH_TYPE_CD.RESET_PASSWORD;
        this.formData.emailVerification.statusCd = EMAIL_VERIFICAION_STATUS_CD.PENDING;
        this.formData.emailVerification.accessKey = res.accessKey;

        await this.updateResetPasswordEmailVerification(
          this.formData.emailVerification,
        );
        this.$router.push({ name: "ResetPasswordCheckAuthCode" });
      } catch (err) {
        console.log(err);
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    toSignInForm() {
      this.$router.push({ name: "SignInForm" });
    },
  },
};
</script>
